import { Mission } from '../../lib/types/models/mission/mission'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMission(id: number) {
  return restApiClient.url(constructApiUrl(API.missions.get.url, { id })).get<Mission>()
}
